export default __webpack_public_path__ + "static/media/logo_sayse_blanc.a561c159.png";